import u from './help/util'
import { Toast } from 'bootstrap'


export const externalLinks = (rootElement=document)=>{
    const currentHost = window.location.hostname;
    // Select all anchor tags
    const links = u.q("a", rootElement);

    links.forEach(link => {
        // Check if the link is external
        if (link.hostname && link.hostname !== currentHost) {
            // Set the target attribute to open in a new window
            link.setAttribute("target", "_blank");

            // Optionally, set rel="noopener noreferrer" for security
            link.setAttribute("rel", "noopener noreferrer");
        }
    }); 
}


export const doToast = (html, container_selector='#toast-container')=>{
    const tpl = `
  <div class="d-flex">
    <div class="toast-body">
    </div>
    <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
  </div>`;
    let el = document.createElement('div');
    el.className = 'toast align-items-center';
    el.innerHTML = tpl;
    u.q('.toast-body',el)[0].innerHTML = html;
    u.q(container_selector)[0].prepend(el);
    let tst  = new Toast(el,{});
    tst.show();
}


export async function xhrSubmit(form, url, callback, statusHandler=false){
    let formData = new FormData(form); 
    formData.append('xhr',1);
    document.body.classList.add('loading')
    try {
        const response = await fetch(url,{
            method: 'POST',
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            body: formData
        });
        if (response.ok) {
            callback(form, response)
        } else {
            if (statusHandler && typeof statusHandler=='function'){
                statusHandler(response.status, response);
            }else{
                alert('something went wrong. Please try again.')
            }
        }
    } catch(err){
        alert('Fetch error:' + err); 
    } finally {
        document.body.classList.remove('loading')
    }
}


export const loadingAnimation = (stop=false)=>{
    if (!stop){
        document.body.classList.add('loading');
    } else {
        document.body.classList.remove('loading');
    }
} 
